<template>
  <v-container fluid class="h-100 esy-wrapper-panel-main moveable">
    <v-row justify="center" align="center" class="h-100">
      <v-col cols="12" sm="10" md="9" lg="8" xl="5" class="esy-oprava-card">
        <v-card>
          <v-card-title>
            <v-row justify="space-between">
              <v-col cols="auto"> {{ $t('Úprava profilu') }} </v-col>
              <v-col cols="auto">
                <v-btn text color="black" class="d-none d-sm-flex" exact :to="{ name: 'Profile' }">
                  <!-- <v-icon small class="mr-2"> fal fa-eye </v-icon> -->
                  <v-icon class="mr-2">fal fa-times</v-icon>

                  {{ $t('Zobrazit profil') }}
                </v-btn>
                <v-btn text color="black" class="d-inline d-sm-none" exact icon :to="{ name: 'Profile' }">
                  <!-- <v-icon small class="mr-2"> fal fa-eye </v-icon> -->
                  <v-icon class="mr-2">fal fa-times</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-tabs background-color="dark" v-model="tab" centered center-active dark>
            <v-tab key="profile_info">{{ $t('Profilové údaje') }}</v-tab>
            <v-tab key="profile_foto">{{ $t('Profilové foto') }}</v-tab>
            <v-tab key="photos">{{ $t('Fotografie') }}</v-tab>
            <v-tab key="password">{{ $t('Heslo') }}</v-tab>
            <v-tab key="deletion">{{ $t('Zrušení účtu') }}</v-tab>
          </v-tabs>

          <v-card-text>
            <v-tabs-items v-model="tab" :show-arrows="false" :touchless="photoDialog">
              <v-tab-item key="profile_info">
                <v-container>
                  <v-row>
                    <!--v-col cols="12">
                                        <v-text-field
                                            label="Přezdívka"
                                            outlined
                                            required
                                        ></v-text-field>
                                    </v-col-->
                    <v-col cols="6">
                      <v-text-field :label="$t('Jméno')" v-model="firstName" outlined hide-details :rules="[
                        (v) =>
                          (v || '').length <= 50 ||
                          $t('Pole může mít maximálně 50 znaků'),
                      ]"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field :label="$t('Příjmení')" v-model="lastName" outlined hide-details :rules="[
                        (v) =>
                          (v || '').length <= 50 ||
                          $t('Pole může mít maximálně 50 znaků'),
                      ]"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field :label="$t('Email')" v-model="email" outlined required hide-details :rules="[
                        (v) =>
                          v.length <= 50 ||
                          $t('Pole může mít maximálně 50 znaků'),
                      ]" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field :label="$t('Bydliště')" v-model="city" hide-details outlined :rules="[
                        (v) =>
                          v.length <= 50 ||
                          $t('Pole může mít maximálně 50 znaků'),
                      ]"></v-text-field>
                    </v-col>
                    <!--
                    <v-col cols="6">
                      <v-text-field :label="$t('Telefon')" v-model="telephone" outlined hide-details :rules="[
                        (v) => !!v || $t('Telefon je povinný údaj'),
                        (v) =>
                          v.length === 9 ||
                          $t('Telefon musí mít přesně 9 číslic'),
                        (v) =>
                          /^\d+$/.test(v) ||
                          $t('Telefon může obsahovat pouze číslice'),
                      ]"></v-text-field>
                    </v-col> -->
                    <!--v-col cols="12" sm="6">
                                        <v-select
                                            :items="['Muž', 'Žena', 'Ostatní']"
                                            label="Pohlaví"
                                            hide-details
                                            outlined
                                        ></v-select>
                                    </v-col-->
                  </v-row>
                  <v-row justify="end">
                    <v-col cols="auto">
                      <v-btn color="green" dark x-large class="font-weight-black" @click="saveProfileInfo"
                        :loading="loading">
                        {{ $t('Uložit') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>

              </v-tab-item>
              <v-tab-item key="profile_foto">
                <div id="photo-tab" style="position: relative">
                    <!-- CROPPER -->
                  <v-dialog :fullscreen="!$vuetify.breakpoint.mdAndUp" v-model="photoDialog" width="500" attach="#photo-tab" hide-overlay style="position: absolute">
                    <v-card>
                      <v-card-title class="d-flex justify-space-between align-center">
                        <span>{{ $t('Nastavení profilové fotografie') }}</span>

                        <v-btn icon @click="photoDialog = false; selectingAvatar = false; profilePhoto = null;" class="ml-2">
                          <v-icon>fal fa-times</v-icon>
                        </v-btn>
                      </v-card-title>

                      <v-card-text>

                        <v-row>
                            <!-- Cropper -->
                            <v-col cols="12">
                                <div style="overflow: hidden; border-radius: 4px; position: relative;">
                                    <div v-if="cropperLoading" class="photo-loading">
                                        <v-progress-circular indeterminate color="green" size="48"></v-progress-circular>
                                        <span>{{ $t('Připravuji fotografii…') }}</span>
                                    </div>
                                    <cropper
                                        class="cropper cropper-wrapper-element"
                                        :src="profilePhotoBase64"
                                        @change="change"
                                        @ready="cropperLoading = false"
                                        @error="cropperLoading = false"
                                        :stencil-props="{
                                            aspectRatio: 1
                                        }"
                                        stencil-component="circle-stencil"
                                    ></cropper>
                                </div>
                            </v-col>

                            <!--
                          <v-col cols="12" class="d-flex justify-center align-center">
                            <div ref="profilePhotoCropper" :style="`background: url('${profilePhotoBase64}') no-repeat 0 0 ; background-size: ${profilePhotoZoom * 100
                              }%; width: 400px; height: 400px; background-color: black; position: relative;`">
                              <svg viewBox="0 0 50 50" width="100%" height="100%"
                                style="position: absolute; top: 0; left: 0;">
                                <defs>
                                  <mask id="mask" x="0" y="0" width="50" height="50">
                                    <rect x="0" y="0" width="50" height="50" fill="#fff" />
                                    <circle cx="25" cy="25" r="21" />
                                  </mask>
                                </defs>
                                <rect x="0" y="0" width="50" height="50" mask="url(#mask)" fill-opacity="0.55" />
                              </svg>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <div class="d-flex align-center">
                              <v-btn small icon @click="profilePhotoZoom = Math.max(1, profilePhotoZoom - 0.2)">
                                <v-icon small>fal fa-minus</v-icon>
                              </v-btn>

                              <div class="slider"
                                style="width: 100%; display: inline-block; margin: 0 10px; height: 10px; background-color: #eee;"
                                ref="slider">
                                <div class="value"
                                  :style="`width: ${(profilePhotoZoom - 1) / 0.02}%; height: 10px; background-color: black;`">
                                </div>
                              </div>

                              <v-btn small icon @click="profilePhotoZoom = Math.min(3, profilePhotoZoom + 0.2)">
                                <v-icon small>fal fa-plus</v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                          -->
                          <v-col cols="12">
                            <v-btn color="green" dark block x-large class="font-weight-black" @click="uploadProfilePhoto"
                              :loading="uploadingAvatar" :disabled="uploadingAvatar">
                              {{ $t('Uložit') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-dialog>

                  <v-container>
                    <v-row justify="center">
                      <v-col cols="auto" class="d-flex flex-column align-center" style="gap: 30px">
                        <v-avatar size="250" color="blue" class="user" :class="{
                          woman: user.sex === 'female',
                          man: user.sex !== 'female',
                        }">
                          <v-img v-if="user.profilePicture" :src="profilePictureSource" @error="user.profilePicture = null">
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="white"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <div v-if="uploadingAvatar" class="photo-loading photo-loading--round">
                            <v-progress-circular indeterminate color="white" size="48"></v-progress-circular>
                            <span>{{ $t('Nahrávám fotografii…') }}</span>
                          </div>
                        </v-avatar>

                        <v-file-input accept="image/jpeg,image/png,image/jpg" :label="$t('Profilový obrázek')"
                          style="min-width: 200px" v-model="profilePhoto" ref="profileUploader" :rules="[
                            (value) =>
                              !value ||
                              value.size < 5000000 ||
                              $t('Avatar musí být menší jak  5 MB!'),
                          ]" class="d-none" @cancel="photoDialog = false; selectingAvatar = false; profilePhoto = null;"></v-file-input>

                        <v-btn color="green" dark x-large class="font-weight-black" :loading="selectingAvatar || processingAvatar || uploadingAvatar" :disabled="processingAvatar || uploadingAvatar"
                          @click="handleProfileFileImport">
                          {{ $t('Vybrat jinou fotografii') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </v-tab-item>
              <v-tab-item key="photos">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="4" md="2" class="h-100" v-for="(picture, i) in user.pictures" :key="i"
                      style="position: relative">
                      <v-img :src="getPictureSource(picture)" height="100%" cover>
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-btn fab x-small color="red" @click="toDelete = i; deleteDialog = true;" class="delete">
                        <v-icon small color="white">fal fa-times</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row v-if="uploadingGallery">
                    <v-col cols="12" sm="4" md="2">
                      <div class="photo-loading photo-loading--tile">
                        <v-progress-circular indeterminate color="green" size="40"></v-progress-circular>
                        <span>{{ uploadingStatus }}</span>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row justify="center">
                    <v-col cols="auto" class="d-flex align-center" style="gap: 30px">
                      <v-file-input accept="image/jpeg,image/png,image/jpg" label="Obrázek" style="min-width: 200px"
                        v-model="photo" ref="photoUploader" :rules="[
                          (value) =>
                            !value ||
                            value.size < 5000000 ||
                            $t('Fotografie musí být menší jak  5 MB!'),
                        ]" class="d-none" @change="uploadPhoto" @cancel="selectingGallery = false"></v-file-input>

                      <v-btn color="green" :dark="user.pictures.length < 6" x-large class="font-weight-black"
                        :loading="selectingGallery || uploadingGallery" :disabled="user.pictures.length >= 6 || uploadingGallery" @click="handleFileImport">
                        {{ $t('Přidat fotografii') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item key="password">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field ref="oldPasswordField" :label="$t('Původní heslo')" autocapitalize="off" autocorrect="off" spellcheck="false" :type="showOldPassword ? 'text' : 'password'" :append-icon="showOldPassword ? 'fal fa-eye-slash' : 'fal fa-eye'" @click:append="showOldPassword = !showOldPassword" v-model="oldPassword" outlined hide-details
                        required :rules="[(v) => !!v || $t('Původní heslo je povinný údaj')]">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field ref="newPasswordField" :label="$t('Nové heslo')" autocapitalize="off" autocorrect="off" spellcheck="false" :type="showNewPassword ? 'text' : 'password'" :append-icon="showNewPassword ? 'fal fa-eye-slash' : 'fal fa-eye'" @click:append="showNewPassword = !showNewPassword" v-model="newPassword" outlined required
                        hide-details :rules="[
                          (v) => !!v || $t('Nové heslo je povinný údaj'),
                          (v) =>
                            v.length >= 8 || $t('Heslo musí mít alespoň 8 znaků'),
                          (v) =>
                            v.length <= 50 ||
                            $t('Heslo může mít maximálně 50 znaků'),
                        ]"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field ref="newPasswordCheckField" :label="$t('Kontrola nového hesla')" autocapitalize="off" autocorrect="off" spellcheck="false" :type="showNewPasswordCheck ? 'text' : 'password'" :append-icon="showNewPasswordCheck ? 'fal fa-eye-slash' : 'fal fa-eye'" @click:append="showNewPasswordCheck = !showNewPasswordCheck" v-model="newPasswordCheck" hide-details
                        outlined required :rules="[
                          (v) => !!v || $t('Kontrola nového hesla je povinný údaj'),
                          (v) =>
                            v.length >= 8 || $t('Heslo musí mít alespoň 8 znaků'),
                          (v) => v === newPassword || $t('Hesla se neshodují'),
                          (v) =>
                            v.length <= 50 ||
                            $t('Heslo může mít maximálně 50 znaků')
                        ]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row justify="end">
                    <v-col cols="auto">
                      <v-btn color="green" dark block x-large class="font-weight-black" @click="changePassword"
                        :loading="loading">
                        {{ $t('Uložit nové heslo') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>

              </v-tab-item>
              <v-tab-item key="deletion">
                <v-container>
                  <v-row>
                    <v-col cols="12">

                      <p class="text-h6 font-weight-black black--text">
                        {{ $t('Smazání Vašeho profilu je nevratná operace. Bude smazán nejen Váš profil, ale tak i Vaše požadavky a fotografie.') }}
                      </p>
                      <p class="font-weight-bold black--text">
                        {{ $t("Pokud chcete profil smazat, zadejte své přihlašovací heslo a stistkněte 'Smazat profil'. Pro větší bezpečnost Vám bude zaslán e-mail s potvrzením, na který budete muset odpovědět.") }}
                      </p>
                    </v-col>
                    <v-col cols="12" md="8" style="margin-top: 0; padding-top: 0; margin-bottom: 0; padding-bottom: 0;">
                    </v-col>
                    <v-col cols="12" md="4" style="margin-top: 0; padding-top: 0; margin-bottom: 0; padding-bottom: 0;">
                      <v-btn color="red" x-large block @click="showDeletionModal = true"> <!-- @click="requestDeletion" -->
                        <span class="white--text font-weight-bold">{{ $t('Zrušit profil') }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="deleteDialog" width="unset" hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title style="margin-right: 40px;">{{ $t('Smazat fotografii?') }}</v-toolbar-title>

                <v-spacer></v-spacer>
 
                <v-btn @click="deleteDialog = false; toDelete = null;" icon color="white">
                    <v-icon>fal fa-times</v-icon>
                </v-btn>
            </v-toolbar>

            <div class="h-100" style="padding: 24px; display: flex; justify-content: center; flex-direction: column;">
                <v-img :src="getPictureSource(user.pictures[toDelete])" height="300px" width="100%" cover></v-img>

                <v-btn color="red" dark @click="deleteDialog = false; deletePhoto(toDelete);" elevation="8" style="margin-top: 24px;">
                    {{ $t('Smazat') }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>

    <!-- Deletion modal -->
    <v-dialog
        v-model="showDeletionModal"
        width="450px"
        >
        <v-card>
            <div style="padding: 20px;">
                <p style="color: black; font-weight: bold; font-size: 18px;">
                    {{ $t('Smazání profilu je nevratné. Jste si skutečně jistý?') }}
                </p>
                <v-text-field :label="$t('Heslo')" autocapitalize="off" autocorrect="off" spellcheck="false" :type="showDeletionPassword ? 'text' : 'password'" :append-icon="showDeletionPassword ? 'fal fa-eye-slash' : 'fal fa-eye'" @click:append="showDeletionPassword = !showDeletionPassword" outlined v-model="deletionPassword" required
                        :rules="[(v) => !!v || 'Heslo je povinný údaj']"></v-text-field>
            </div>

            

            <v-card-actions style="padding: 20px; flex: row;">
                <v-btn color="#92A913" style="color: white; padding: 24px; font-weight: bold; width: 50%; min-width: 0 !important;" block @click="showDeletionModal = false" >{{ $t('Zpět') }}</v-btn>
                <v-btn dark color="red" style="color: white; padding: 24px; font-weight: bold; width: 50%; min-width: 0 !important;" block @click="requestDeletion">{{ $t('Smazat') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { pictureSource } from "@/utils/pictures";
import { URL } from "@/store/index";
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

// Phone photos are 5–10 MB while the server stores them at 500 px: shrink them first so the upload is fast.
// Falls back to the original file when the browser cannot decode or re-encode it.
const shrinkImage = async (file, maxSide = 1600, quality = 0.85) => {
  try {
    if (typeof createImageBitmap !== "function") return file;

    const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
    const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    if (bitmap.close) bitmap.close();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
    if (!blob || blob.size === 0 || blob.size >= file.size) return file;

    return new File([blob], "photo.jpg", { type: "image/jpeg" });
  } catch (e) {
    console.warn("Could not shrink image, uploading the original:", e);
    return file;
  }
};

const dataURLtoFile = async (url, file) => {
  console.log("getting file from url: ", url, " with name: ", file);

  const response = await fetch(url);
  const data = await response.blob();

  return new File([data], file, {
    type: data.type || "image/jpeg",
  });
};

export default {
  name: "ProfileEdit",

  computed: {
    user() {
      let user = this.$store.state.user;

      if (user.firstName == "-")
        user.firstName = "";

      if (user.lastName == "-")
        user.lastName = "";

      return user;
    },

    profilePictureSource() {
      return URL + this.user.profilePicture;
    },
  },

  data: () => ({
    tab: "photos",

    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    city: "",
    showDeletionModal: "",

    profilePhoto: null,
    photoDialog: false,
    profilePhotoZoom: 1,
    profilePhotoBase64: null,
    profilePhotoChange: null,
    photo: null,

    oldPassword: "",
    newPassword: "",
    newPasswordCheck: "",

    deletionPassword: "",
    showOldPassword: false,
    showNewPassword: false,
    showNewPasswordCheck: false,
    showDeletionPassword: false,

    loading: false,

    // Each button has its own busy state so a spinner can never leak from one upload to another.
    selectingAvatar: false,
    uploadingAvatar: false,
    selectingGallery: false,
    uploadingGallery: false,
    uploadingStatus: "",
    processingAvatar: false,
    cropperLoading: false,

    toDelete: null,
    deleteDialog: false
  }),

  beforeDestroy() {
    clearTimeout(this.cropperLoadingTimer);
    document.removeEventListener("visibilitychange", this.onVisible);
  },

  watch: {
    async profilePhoto(file) {
      if (!file) return;

      // Show feedback right away: reading a large photo and drawing the cropper takes a moment.
      this.processingAvatar = true;
      this.cropperLoading = true;
      try {
        const base64 = await toBase64(file);

        // The cropper only reports "ready" when its image actually changes: the same photo picked again must not
        // leave the loading overlay up. The timeout is a last resort for any other case.
        if (base64 === this.profilePhotoBase64) this.cropperLoading = false;
        clearTimeout(this.cropperLoadingTimer);
        this.cropperLoadingTimer = setTimeout(() => { this.cropperLoading = false; }, 5000);

        this.profilePhotoBase64 = base64;
        this.selectingAvatar = false;
        this.photoDialog = true;
      } catch (e) {
        console.error(e);
        this.cropperLoading = false;
      } finally {
        this.processingAvatar = false;
      }
    }
  },

  mounted() {
    this.resetSelecting = () => {
      this.selectingGallery = false;
      this.selectingAvatar = false;
    };
    this.onVisible = () => { if (!document.hidden) setTimeout(this.resetSelecting, 800); };
    document.addEventListener("visibilitychange", this.onVisible);

    this.firstName = this.user.firstName || "";
    this.lastName = this.user.lastName || "";
    this.email = this.user.email;
    this.telephone = this.user.telephone;
    this.city = this.user.city;

    // Handle tab query parameter (e.g., from Settings page)
    if (this.$route.query.tab !== undefined) {
      this.tab = parseInt(this.$route.query.tab);
    }
  },

  methods: {
    change({ coordinates, canvas }) {
        this.profilePhotoChange = { coordinates, canvas };
    },
    getPictureSource(picture, user) {
        return pictureSource(picture, user);
    },

    async saveProfileInfo() {
      this.loading = true;
      const user = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        telephone: this.telephone,
        city: this.city,
      };

      const start = Date.now();
      const result = await this.$store.dispatch("updateUser", user);

      // On failure the store has already shown the server's reason.
      if (!result) {
        this.loading = false;
      } else {
        if (start + 1000 > Date.now()) {
          setTimeout(() => {
            this.loading = false;
            this.$root.$emit("notification", {
              message: this.$t("Úspěšně uloženo!"),
              duration: 2,
            });
          }, 1000 - (Date.now() - start));
        } else {
          this.loading = false;
          this.$root.$emit("notification", {
            message: this.$t("Úspěšně uloženo!"),
            duration: 2,
          });
        }
      }
    },

    // v-file-input does not forward the native "cancel" event of its hidden <input>, and Android WebView does not
    // reliably fire window "focus" after the picker closes – listen on the input itself so spinners always stop.
    // The same function reference is registered every time, so repeated calls do not stack listeners.
    watchFileInput(uploader) {
      const input = uploader && uploader.$refs && uploader.$refs.input;
      if (!input) return;
      input.addEventListener("cancel", this.resetSelecting);
      input.addEventListener("change", this.resetSelecting);
    },

    handleProfileFileImport() {
      this.selectingAvatar = true;
      this.watchFileInput(this.$refs.profileUploader);

      // The system picker gives no event when it is dismissed without a choice; the window regains focus then.
      window.addEventListener("focus", () => {
        setTimeout(() => { if (!this.profilePhoto) this.selectingAvatar = false; }, 800);
      }, { once: true });

      this.$refs.profileUploader.$refs.input.click();
    },

    async uploadProfilePhoto() {
        if (this.uploadingAvatar) return;
        this.uploadingAvatar = true;

        try {
            await this.saveProfilePhoto();
        } catch (e) {
            console.error(e);
            this.$root.$emit("notification", {
                message: this.$t("Něco se pokazilo. Zkuste to prosím později."),
                type: "error",
                duration: 6,
            });
        } finally {
            // Whatever happened, the button must not keep spinning.
            this.uploadingAvatar = false;
        }
    },

    async saveProfilePhoto() {
        /*
      // Crop image by this.$refs.profilePhotoCropper - consider zoom and bg position
      const bgPosX = parseFloat(
        getComputedStyle(this.$refs.profilePhotoCropper).backgroundPositionX
      );
      const bgPosY = parseFloat(
        getComputedStyle(this.$refs.profilePhotoCropper).backgroundPositionY
      );
      const bgSize = parseFloat(
        getComputedStyle(this.$refs.profilePhotoCropper).backgroundSize
      );

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const img = new Image();
      img.src = this.profilePhotoBase64;

      canvas.width = 500;
      canvas.height = 500;

      const ratio = Math.min(
        canvas.width / img.width,
        canvas.height / img.height
      );

      console.log(ratio);

      const border = 32 / ratio;
      ctx.drawImage(
        img,
        0 + border / 2,
        0 + border / 2,
        img.width - border,
        img.height - border,
        bgPosX,
        bgPosY,
        ((img.width * bgSize) / 100) * ratio,
        ((img.height * bgSize) / 100) * ratio
      );

      console.log(
        img.width,
        img.height,
        bgPosX,
        bgPosY,
        bgSize,
        ((img.width * bgSize) / 100) * ratio,
        ((img.height * bgSize) / 100) * ratio
      );
      */

        let canvas = this.profilePhotoChange.canvas;

        // The server stores the avatar at 400 px – no need to send the full-resolution crop.
        const maxSide = 800;
        const scale = Math.min(1, maxSide / Math.max(canvas.width, canvas.height));
        let source = canvas;
        if (scale < 1) {
            source = document.createElement("canvas");
            source.width = Math.round(canvas.width * scale);
            source.height = Math.round(canvas.height * scale);
            source.getContext("2d").drawImage(canvas, 0, 0, source.width, source.height);
        }

        let url = source.toDataURL("image/jpeg", 0.9);

        // Convert to File
        let profilePhoto = await dataURLtoFile(url, "profilePhoto.jpg");

        if (profilePhoto.size == 0) {
            this.$root.$emit("notification", {
                message: this.$t("Něco se pokazilo. Zkuste to prosím později."),
                type: "error",
                duration: 6,
            });
            this.profilePhoto = null;
            this.photoDialog = false;
            this.uploadingAvatar = false;
            return;
        }

        const result = await this.$store.dispatch(
            "uploadProfilePicture",
            profilePhoto
        );

        if (!result) {
            this.profilePhoto = null;
            this.photoDialog = false;
            this.uploadingAvatar = false;
            return;
        }

        this.profilePhoto = null;
        this.photoDialog = false;
        this.selectingAvatar = false;
        this.uploadingAvatar = false;

        this.$root.$emit("notification", {
            message: this.$t("Úspěšně nahráno!"),
            duration: 2,
        });
    },

    handleFileImport() {
      this.selectingGallery = true;
      this.watchFileInput(this.$refs.photoUploader);

      // The system picker gives no event when it is dismissed without a choice; the window regains focus then.
      window.addEventListener("focus", () => {
        setTimeout(() => { if (!this.uploadingGallery) this.selectingGallery = false; }, 800);
      }, { once: true });

      this.$refs.photoUploader.$refs.input.click();
    },

    async uploadPhoto(selected) {
      let photo = selected || this.photo;

      this.selectingGallery = false;

      if (!photo || this.uploadingGallery) return;

      if (photo.type && !photo.type.startsWith("image/")) {
        this.photo = null;
        this.$root.$emit("notification", {
          message: this.$t("Vyberte prosím obrázek (JPG, PNG)."),
          type: "error",
          duration: 6,
        });
        return;
      }

      if (photo.size > 10 * 1024 * 1024) {
        this.photo = null;
        this.$root.$emit("notification", {
          message: this.$t("Fotka je příliš velká (maximum je 10 MB)."),
          type: "error",
          duration: 6,
        });
        return;
      }

      this.uploadingGallery = true;
      this.uploadingStatus = this.$t("Připravuji fotografii…");

      try {
        photo = await shrinkImage(photo);
        this.uploadingStatus = this.$t("Nahrávám fotografii…");

        const result = await this.$store.dispatch("uploadPicture", photo);

        this.photo = null;

        if (!result) return;

        this.$root.$emit("notification", {
          message: this.$t("Úspěšně nahráno!"),
          duration: 2,
        });
      } finally {
        this.uploadingGallery = false;
      }
    },
    async deletePhoto(index) {
      const result = await this.$store.dispatch("deletePicture", index);

      if (!result) return;

      this.$root.$emit("notification", {
        message: this.$t("Úspěšně smazáno!"),
        duration: 2,
      });
    },

    async changePassword() {
      this.loading = true;
      const data = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      const start = Date.now();
      const result = await this.$store.dispatch("updateUserPassword", data);

      if (!result) {
        this.loading = false;
      } else {
        if (start + 1000 > Date.now()) {
          setTimeout(() => {
            this.loading = false;
          }, 1000 - (Date.now() - start));
        } else {
          this.loading = false;
        }

        this.$root.$emit("notification", {
          message: this.$t("Heslo bylo úspěšně změněno."),
          duration: 6,
        });

        this.oldPassword = "";
        this.newPassword = "";
        this.newPasswordCheck = "";
        this.showOldPassword = false;
        this.showNewPassword = false;
        this.showNewPasswordCheck = false;

        // Emptying the fields would otherwise light them up as "required" errors.
        this.$nextTick(() => {
          ["oldPasswordField", "newPasswordField", "newPasswordCheckField"].forEach((name) => {
            if (this.$refs[name]) this.$refs[name].resetValidation();
          });
        });
      }
    },

    async requestDeletion() {
      const result = await this.$store.dispatch("requestDeletion", {
        password: this.deletionPassword,
      });

      if (result) {
        this.$root.$emit("notification", {
          message: this.$t("Váš účet byl smazán."),
          duration: 6,
        });

        this.$store.dispatch("logOut");
        this.$router.push({ name: "Home" });
      }
    },
  },
};
</script>

<style lang="scss">
@media only screen and (max-width: 992px) { 
    .esy-oprava-card > div {
        height: 100% !important;
        border-radius: 0 !important;
        box-shadow: none !important;
    }
}

.vue-simple-handler {
    background: #92A913 !important;
}

</style>

<style lang="scss" scoped>

.photo-loading {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.85);
  pointer-events: none; /* never block the cropper underneath, even if the overlay is shown too long */
  font-size: 14px;
  text-align: center;
}

.photo-loading--round {
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: white;
}

.photo-loading--tile {
  position: relative;
  inset: auto;
  aspect-ratio: 1;
  border: 1px dashed #bbb;
  border-radius: 4px;
}

.cropper-wrapper-element {
    max-height: 400px !important;
}

.h-100 {
  height: 100%;
}

.delete {
  position: absolute;
  top: 0;
  right: 0;
}

@media only screen and (max-width: 992px) {
    .v-main__wrap {
        display: block !important;
    }

    .esy-wrapper-panel-main {
        padding: 0 !important;
        width: 100%;
        overflow-x: hidden !important;
        height: calc(100vh - 48px);
        min-height: 0 !important;
    }

    .esy-wrapper-panel-main > div {
        align-items: start !important;
    }

    .esy-wrapper-panel-main > div > div {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }
}

.moveable {
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 10px;
    }

    &::-webkit-scrollbar-track {
        background: #f3f3f3;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: #7a9704;
        border-radius: 10px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
}
</style>